export function getStyleContents(html: string): string {
  const match = html.match(/<style[^>]*>([\s\S]*?)<\/style>/i);
  return match ? match[1] : "";
}

export const EMAIL_DOCTYPE = "<!doctype html>";

// Helper functions specific to saving

// Rebuild the email HTML with the styles from the original content. We strip these out when editing because grapes does weird stuff.
export function rebuildEmailHtml(
  originalContent: string,
  updatedContent: string,
): string {
  const styleContents = getStyleContents(originalContent) || "";
  const htmlWithStyles = updatedContent.replace(
    "</head>",
    `\n<style>${styleContents}</style>\n</head>`,
  );

  return (EMAIL_DOCTYPE + "\n" + htmlWithStyles).replace(
    "<title/>",
    "<title></title>",
  );
}
